// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FieldLabel{align-items:center;display:inline-flex;justify-content:flex-start}.FieldLabel-Star{color:var(--color-bg-alert);margin-left:var(--space-3xs)}`, "",{"version":3,"sources":["webpack://./../node_modules/@consta/uikit/__internal__/src/components/FieldLabel/FieldLabel.css"],"names":[],"mappings":"AAAA,YAAY,kBAAkB,CAAC,mBAAmB,CAAC,0BAA0B,CAAC,iBAAiB,2BAA2B,CAAC,4BAA4B","sourcesContent":[".FieldLabel{align-items:center;display:inline-flex;justify-content:flex-start}.FieldLabel-Star{color:var(--color-bg-alert);margin-left:var(--space-3xs)}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FieldLabel": `FieldLabel`,
	"FieldLabel-Star": `FieldLabel-Star`
};
export default ___CSS_LOADER_EXPORT___;
